import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { useIcdCodeByDiagnosisCodeQuery } from "@/modules/patients/detail/progress-note/hooks/__generated__/useIcdCodeByDiagnosisCodeQuery.graphql"

const icdCodeByDiagnosisCodeQuery = graphql`
  query useIcdCodeByDiagnosisCodeQuery($diagnosisCode: String!, $skip: Boolean!) {
    icdDiagnosisByDiagnosisCode(diagnosisCode: $diagnosisCode) @skip(if: $skip) {
      id
      diagnosisCode
      text
      ...IcdDiagnosisFragment
    }
  }
`

interface useIcdCodeByIdProps extends FetchKeyProps {
  diagnosisCode: string
  skip: boolean
}

const useIcdCodeByDiagnosisCode = ({ diagnosisCode, skip, fetchKey }: useIcdCodeByIdProps) => {
  const data = useLazyLoadQuery<useIcdCodeByDiagnosisCodeQuery>(
    icdCodeByDiagnosisCodeQuery,
    { diagnosisCode, skip },
    { fetchKey },
  )

  return {
    diagnosisCode,
    code: data.icdDiagnosisByDiagnosisCode?.diagnosisCode,
    description: data.icdDiagnosisByDiagnosisCode?.text,
  }
}

export { icdCodeByDiagnosisCodeQuery, useIcdCodeByDiagnosisCode }
